// Source: https://usehooks.com/useOnScreen/
import { useState, useEffect, useRef, useCallback } from 'react';
export default function useOnScreen(ref, rootMargin = '0px') {
    // State and setter for storing whether element is visible
    const [isIntersecting, setIntersecting] = useState(false);
    useEffect(() => {
        const observer = new IntersectionObserver(([entry]) => {
            // Update our state when observer callback fires
            if (ref.current) {
                setIntersecting(entry.isIntersecting);
            }
        }, {
            rootMargin,
        });
        if (ref.current) {
            observer.observe(ref.current);
        }
        return () => {
            observer.disconnect();
        };
    }, []); // Empty array ensures that effect is only run on mount and unmount
    return isIntersecting;
}
// This ref callback can be used on elements that are behind condition, and will not be show on first render
// eg. because it waits for response from an api
export function useOnScreenCallback(rootMargin = '0px') {
    const ref = useRef(null);
    const [isIntersecting, setIntersecting] = useState(false);
    const observer = new IntersectionObserver(([entry]) => {
        // Update our state when observer callback fires
        setIntersecting(entry.isIntersecting);
    }, {
        rootMargin,
    });
    const setRef = useCallback((node) => {
        if (ref.current) {
            observer.unobserve(ref.current);
        }
        if (node) {
            observer.observe(node);
        }
        ref.current = node;
    }, []);
    return [isIntersecting, setRef];
}
